/* eslint-disable max-lines */
//  internal deps
import Analytics, { DEFAULT_ANALYTICS_CONTEXT_VALUE, getAnalyticsConfigParams } from "@swiggy-private/analytics";
import { AnalyticsContextValue } from "@swiggy-private/analytics/dist/contexts";

const ANALYTICS_HOST = "https://analytics.swiggy.com";
export const SCREEN_NAME = {
    HOME_PAGE: "landing-page-coupon-redemption",
    HOME_PAGE_UNAVAILABLE: "landing_page_SWIGGY_ONE_unavialble",
    CART_PAGE: "landing-page-coupon-confirm",
};

export const getAnalyticsContextValue = (swiggyHeaders: any): AnalyticsContextValue => {
    const analyticsConfig = getAnalyticsConfigParams(
        swiggyHeaders,
        process.env.NEXT_PUBLIC_ANALYTICS_HOST || ANALYTICS_HOST,
    );
    const analytics = (analyticsConfig && new Analytics(analyticsConfig)) || DEFAULT_ANALYTICS_CONTEXT_VALUE;
    return analytics;
};
